import axiosAuth from '../../axiosMain';

async function index(params = {}) {
  let response = await axiosAuth.get('/consumption_notifications', { params });
  return response.data;
}

async function markAsRead(notificationId) {
  let response = await axiosAuth.get(`consumption_notifications/${notificationId}/mark-as-read`);
  return response.data.data;
}

export default {
  index,
  markAsRead,
};
